import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
 email = "";
 password = "";
 user : any;
 hide  : boolean;
  constructor(private AuthService : AuthService , private Router : Router) {
    this.hide = true;
   }
 
  ngOnInit() {
  }
  login(){
    if(this.email != '' && this.password != ''){
      this.AuthService.login(this.email , this.password).then(user => {
        if (user){
          this.user = user;
          localStorage.setItem('user', JSON.stringify(this.user));
          this.Router.navigate(['/landing']);
        } else {
    
          localStorage.setItem('user', null);
        }
      })
      .catch(err => {
             alert(err.message);
      })
    }
 
  }
  toggleHidden(){
     this.hide = !this.hide;
  }

}
